import Vue from 'vue';
import {
  getProducts, getCategory
} from '../../../services/backendService/productBuyService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  products: [],
  categories: [],
  pagination: {
    current_page: 0,
    per_page: 20
  }
};

 // actions
const actions = {
  //* *** 後台商品 ****//
  // 取得後台商品
  async getProductsHandler({ commit }, formData) {
    const data = await getProducts(formData);
    commit('setProducts', data);
  },
  // 取得後台類別
  async getCategoryHandler({ commit }) {
    const data = await getCategory();
    commit('setCategory', data);
  },
};

// mutations
const mutations = {
  setProducts(state, data) {
    Vue.set(state, 'products', state.products.concat(data.data.products));
    Vue.set(state, 'pagination', data.pagination);
  },
  setCategory(state, data) {
    Vue.set(state, 'categories', data.data.data);
  },
  // 重置分頁
  resetInfiniteLoadingData(state) {
    Vue.set(state, 'products', []);
    Vue.set(state, 'pagination', {
      current_page: 0,
      per_page: 20
    });
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};




// 測試假資料
let testCategory = [
  {
    label: "台北市", value: "10",
    children: [
      { 
        label: "中正區", value: "101",
        children: [
          { label: "新光三越店", value: "1011" },
          { label: "旗艦一館", value: "1012" },
        ]
      },
      { 
        label: "信義區", value: "102",
      },
    ]
  },
  {
    label: "台中市", value: "11",
    children: [
      { 
        label: "豐原區", value: "110",
        children: [
          { label: "新光四越店", value: "1101" },
          { label: "旗艦二館", value: "1102" },
        ]
      },
      { 
        label: "清水區", value: "111",
        children: [
          { label: "台中102店", value: "1111", disabled: true },
          { label: "強風光南店", value: "1112", disabled: true },
        ]
      },
    ]
  },
  {
    label: "台南市", value: "12",
  },
]